import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import {
  CropsDTO,
  CropsYieldEvolutionDTO,
  HarvestDataOverrideDTO,
  HarvestDataOverrideResponse,
} from "./types";

const MS_URL = "/senana/farm/analysis";
const MS_URL_EVOLUTION = "/senana/farm/crops";
const responseAsCrops = responseContent(CropsDTO);

const cropsYieldEvolutionResponseDTOParser = responseContent(CropsYieldEvolutionDTO);

export const getCropsByFarmAnalysisUuid = async (
  analysisUuid: string,
  harvestSeason: string = "SUMMER",
  cropType: string | undefined = undefined
): Promise<ResponseContent<CropsDTO[]>> =>
  axios
    .get(`${MS_URL}/${analysisUuid}/crops`, {
      params: { harvestSeason, cropType }
    })
    .then(responseAsCrops);

export const resetCrop = async (uuid: string) => axios
  .patch(`${MS_URL}/crops/${uuid}/reset`)
  .then(responseContent(Object));

export const getCropsYieldEvolution = async (uuid: string, harvestSeason: string, cropType: string) => axios
  .get(`${MS_URL_EVOLUTION}/${uuid}/yield-evolution`, { params: { harvestSeason, cropType }})
  .then(cropsYieldEvolutionResponseDTOParser);

export const override = async (senanaAnalysisUuid: string, data: [], analysisYear: number) => axios
  .put(`${MS_URL}/${senanaAnalysisUuid}/${analysisYear}/crops/override`, data);

export const overrideHarvestData = async (
  analysisUuid: string,
  edits: HarvestDataOverrideDTO[]
): Promise<{ data: HarvestDataOverrideResponse }> =>
  axios.patch(`${MS_URL}/${analysisUuid}/harvest-data/override`, edits);
